<script lang="ts" setup>
import GoalsMenu from '../components/goals/GoalsMenu.vue';
import GoalsList from '../components/goals/GoalsList.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <GoalsMenu />
  <GoalsList v-if="route.path === '/goals'" />
</template>
